module.exports = "<p-button icon=\"fa fa-search\" label=\"{{ 'LAYOUT:BUTTON:SEARCH_RC' | translate }}\" (onClick)=\"showSearchRC()\"></p-button>\r\n"